export default __webpack_public_path__ + "static/media/summit.f8b60f4e.jpg";